import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { GlobalContext } from 'providers/GlobalProvider';
import CyberProtectionReact from './CyberProtectionReact';

const CyberProtection: React.FC = () => {
  const { cur_user } = useContext(GlobalContext);

  if (!cur_user.selected_team) {
    return <Redirect to='/' />;
  }

  return (
    <CyberProtectionReact />
  );
};

export default CyberProtection;
